import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import EditTemplateForm from './EditTemplateForm'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'
import TemplateLoader from './_load/TemplateLoader'

const TemplatesModal = props => {
  return (
    <ControlledModal width="32rem" {...props}>
      <TemplateLoader>
        <ModalHeader />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={4} />
        <EditTemplateForm />
      </TemplateLoader>
    </ControlledModal>
  )
}

export default TemplatesModal
